// src/locales/es.js
export default {
  // ============================================================
  // TÍTULOS Y TEXTOS PRINCIPALES
  // ============================================================
  title: 'STRATIUM GLOBAL AI',
  subtitle: 'Especialista en Optimización de Costos y Auditoría Financiera con IA',
  
  // ============================================================
  // PLANES Y PRECIOS
  // ============================================================
  planStarter: 'Starter',
  planPro: 'Pro',
  planBusiness: 'Business',
  planElite: 'Elite',
  planStarterPrice: '$0 / 15 días',
  planProPrice: '$79,900/mes',
  planBusinessPrice: '$199,900/mes',
  planElitePrice: '$499,900/mes',
  planStarterPriceUSD: '$0 / 15 days',
  planProPriceUSD: '$29.99/mo',
  planBusinessPriceUSD: '$79.99/mo',
  planElitePriceUSD: '$199.99/mo',
  scans: 'Escaneos',
  days: 'Días',
  capitalInjected: 'Capital Inyectado',
  
  // ============================================================
  // BOTONES Y ACCIONES
  // ============================================================
  audit: 'Auditoría',
  exportCSV: 'Exportar CSV',
  attach: 'Adjuntar',
  attaching: 'Adjuntando...',
  scanInvoice: 'Escanear Factura',
  processingOCR: 'Procesando OCR...',
  viewLogs: 'Ver Logs',
  logout: 'Cerrar Sesión',
  connecting: 'Conectando...',
  online: 'En línea',
  generating: 'Generando...',
  report: 'Reporte',
  analyze: 'Analizar',
  pdfReport: 'Reporte PDF',
  save: 'Guardar',
  cancel: 'Cancelar',
  close: 'Cerrar',
  configure: 'Configurar',
  upgrade: 'Actualizar',
  upgradeToCompare: 'Actualiza para ver comparación',
  pagar: 'Pagar',
  comprar: 'Comprar',
  saving: 'Guardando...',
  
  // ============================================================
  // DASHBOARD Y KPIS
  // ============================================================
  sales: 'Ventas',
  profit: 'Utilidad',
  margin: 'Margen',
  balance: 'Saldo en Caja',
  salesVariation: 'vs mes anterior',
  netPeriod: 'Neto del período',
  onSales: 'Sobre ventas',
  historicalBalance: 'Saldo histórico',
  positive: 'Positivo',
  negative: 'Negativo',
  cashRunway: 'Oxígeno financiero',
  healthThermometer: 'Termómetro de Salud',
  incomeVsExpenses: 'Ingresos vs Egresos',
  financialAlerts: 'Alertas del Sargento Financiero',
  strategicRecommendations: 'Recomendaciones Estratégicas',
  alerts: '🚨 Alertas del Sargento Financiero',
  expenses: 'Gastos',
  purchases: 'Compras',
  capital: 'Capital',
  currentPeriod: 'Período actual',
  
  // ============================================================
  // PRODUCCIÓN
  // ============================================================
  productionOrder: '🏭 Orden de Producción v2.4-International',
  productionSubtitle: 'Precisión financiera con prorrateo por esfuerzo y capacidad instalada',
  totalBatchHours: 'Horas Totales Lote',
  exampleHours: 'Ej: 40',
  hourlyRateValue: 'Valor Hora Base ($)',
  transportLogistics: 'Transporte/Logística ($)',
  additionalExpenses: 'Gastos Adicionales ($)',
  batchItems: '📦 Ítems del Lote (con esfuerzo horario)',
  addItem: '+ Agregar',
  product: 'Producto',
  quantity: 'Cantidad',
  price: 'Precio',
  materialsPerUnit: 'Materiales/Und',
  delete: '🗑️',
  auditFullBatch: '🔍 Auditar Lote Completo (v2.4-International)',
  footerText1: 'Stratium GLOBAL AI v2.4-International • CO • EN',
  footerText2: 'Factor prestacional: 1.52x • Comisión: 27.1% • Provisión: $10,000/und',
  footerText3: 'Auditoría financiera inteligente para emprendedores reales',
  productionAudit: 'Auditoría de Producción',
  loadingAuditEngine: 'Cargando motor de auditoría...',
  hoursPerUnit: 'Horas/Und',
  estimatedHours: 'Horas estimadas por unidad',
  risk: 'RIESGO',
  optimal: 'ÓPTIMO',
  profitable: 'RENTABLE',
  totalVariableCost: 'Costo Var. Total',
  costIncludes: 'Incluye: Materiales + Comisión 27.1% + Labor',
  provision: 'Provisión',
  auditedProfit: 'Utilidad Auditada',
  profitDescription: 'Utilidad neta después de todos los costos variables + provisión prudencial de $10,000 para gastos fijos mensuales.',
  auditedMargin: 'Margen Auditado',
  breakEvenPoint: 'Punto Equilibrio',
  laborPerUnit: 'Labor Unit. (Audit.)',
  cifPerUnit: 'CIF Unitario',
  channelCommission: 'Comisión Canal',
  priceSimulator: 'Simulador de Precios para Márgenes 10-40%',
  forMargin: 'Para',
  increase: 'Subir',
  decrease: 'Bajar',
  current: 'Actual',
  totalContribution: 'Contribución total',
  installedCapacity: 'Capacidad Instalada - Absorción de Gastos Fijos',
  monthlyFixedExpenses: 'Gastos Fijos Mensuales',
  accumulatedAbsorption: 'Absorción Acumulada (mes)',
  currentLotContribution: 'Contribución Lote Actual',
  totalProjected: 'Total Proyectado',
  covered: 'cubierto',
  remainingToCover: 'Faltan',
  toCoverFixedCosts: 'para cubrir gastos fijos del mes',
  fixedCostsCovered: 'Gastos fijos mensuales completamente cubiertos',
  auditing: 'Auditando con precisión...',
  registering: 'Registrando en Blockchain financiero...',
  negativeMarginWarning: 'Algunos productos tienen margen negativo. ¿Quieres revisarlos antes de guardar?',
  registerLot: 'Registrar Lote con Trazabilidad Completa',
  
  // ============================================================
  // CONFIGURACIÓN DE AUDITORÍA
  // ============================================================
  auditConfigTitle: '⚙️ Configuración de Auditoría',
  auditConfigSubtitle: 'Define los parámetros financieros de tu negocio para una auditoría precisa',
  operationRegion: 'Región de operación',
  southAmerica: 'América del Sur',
  monthlyFixedCosts: 'Gastos Fijos Mensuales',
  fixedCostsPlaceholder: 'Arriendo + Servicios + Nómina Administrativa + Software + Publicidad',
  mainSalesPlatform: 'Plataforma de venta principal',
  ownPlatform: 'PROPIA',
  saveConfig: 'Guardar Configuración',
  closeConfig: 'Cerrar',
  configuracionAuditoria: 'Configuración de Auditoría',
  configurar: 'Configurar',
  region: 'Región',
  gastosFijos: 'Gastos Fijos Mensuales',
  plataforma: 'Plataforma de venta principal',
  guardar: 'Guardar Configuración',
  fixedCostsRequired: '⚠️ Los gastos fijos mensuales son obligatorios',
  configSaved: '✅ Configuración guardada exitosamente',
  configError: '❌ Error al guardar la configuración',
  selectorPais: 'Selecciona tu país',
  saveConfiguration: 'Guardar configuración',
  
  // ============================================================
  // SALUD Y ESTADOS
  // ============================================================
  healthExcellent: 'Excelente',
  healthStable: 'Estable',
  healthCritical: 'Crítico',
  noData: 'Sin datos',
  viewFullHistory: 'Ver historial completo',
  totalTransactions: 'transacciones',
  
  // ============================================================
  // SLEEP INDICATOR (DÍAS CUBIERTOS)
  // ============================================================
  daysCovered: '{dias}/{total} días',
  sleepIndicator: '😴 Días de gastos cubiertos',
  sleepIndicatorAria: 'Indicador de días cubiertos',
  mensajeSueñoExcelente: '🎉 Excelente. Tus gastos fijos del mes ya están cubiertos.',
  mensajeSueñoBueno: 'Te faltan {dias} días para cubrir los gastos fijos del mes.',
  mensajeSueñoRegular: 'Cubres {dias} días de gastos fijos.',
  mensajeSueñoCritico: '🚨 No has generado utilidad suficiente para cubrir gastos fijos.',
  mensajeSinDatos: 'Registra tus gastos fijos y ventas para ver cuántos días cubres.',
  coveredLabel: 'Cubierto:',
  missingLabel: 'Faltante:',
  tooltipAuditedProfit: 'Utilidad neta = Ventas - Costos variables. Los gastos fijos se restan aquí para calcular días cubiertos.',
  
  // ============================================================
  // TRUST METER (NIVEL DE CONFIANZA)
  // ============================================================
  auditTrustLevel: '📊 Nivel de Confianza de la Auditoría',
  trustMessageLow: '💡📝 Registra tus ventas y gastos diarios para obtener insights reales de tu negocio',
  lowConfidence: 'Confianza baja',
  mediumConfidence: 'Confianza media',
  highConfidence: 'Confianza alta',
  
  // ============================================================
  // USER GREETING (SALUDO)
  // ============================================================
  goodEvening: 'Buenas tardes',
  goodMorning: 'Buenos días',
  goodAfternoon: 'Buenas tardes',
  from: 'de',
  letsTakeCare: '🇨🇴 ¡Vamos a cuidar tu negocio!',
  regionLabel: '🌐 Región',
  currencyLabel: '💱 Moneda',
  localTime: 'Hora local',
  
  // ============================================================
  // REGISTRO MANUAL
  // ============================================================
  tituloRegistroManual: 'Registro Manual de Movimientos',
  tipoMovimiento: 'Tipo de movimiento',
  gasto: 'Gasto',
  ingreso: 'Ingreso',
  compraInventario: 'Compra (inventario)',
  venta: 'Venta',
  fuentePago: 'Pagado con...',
  fuenteNegocio: '💰 Fondos del negocio',
  fuentePersonal: '👤 Fondos personales (Inyección de capital)',
  montoTotal: 'Monto Total',
  fecha: 'Fecha',
  tercero: 'Proveedor / Cliente',
  tipoPago: 'Tipo de pago',
  contado: '💰 Contado',
  credito: '📅 Crédito',
  fechaLimitePago: 'Fecha límite de pago',
  fechaVencimientoProducto: 'Fecha de vencimiento del producto',
  ejemploConcepto: 'Escribe el nombre del producto...',
  guardar: 'Registrar Movimiento',
  guardando: 'Guardando...',
  exito: '✅ Movimiento registrado exitosamente',
  advertenciaPersonal: '⚠️ Estás inyectando capital personal al negocio. Esto genera una deuda del negocio contigo.',
  saldoInsuficiente: '❌ No se puede registrar este gasto. Saldo insuficiente. Disponible: {saldo}. Necesitas: {monto}.',
  stockInsuficiente: '❌ No se puede registrar la venta. Stock insuficiente. Disponible: {stock} unidades. Solicitado: {solicitado} unidades.',
  productosCriticos: '🦴 Productos Críticos (HUESO)',
  productosEstrella: '⭐ Productos Estrella',
  sinProductosCriticos: '✅ No hay productos HUESO en inventario',
  sinProductosEstrella: '⚠️ Aún no hay productos ESTRELLA',
  infoProducto: '📊 Información del Producto',
  clasificacion: 'Clasificación',
  diasSinVentas: 'Días sin ventas',
  margen: 'Margen',
  precioLiquidacion: 'Precio sugerido para liquidar',
  estrategia: 'Estrategia',
  liquidacionPerdida: '💀 PÉRDIDA CONTROLADA',
  recuperarCapital: '💰 RECUPERAR CAPITAL',
  alCosto: '📦 AL COSTO',
  promocionLigera: '🔥 PROMOCIÓN LIGERA',
  urgencia180: '⚠️ URGENTE: más de 180 días',
  urgencia90: '⚠️ Alerta: más de 90 días',
  urgencia60: '⚡ Recupera inversión',
  urgencia30: '💡 Libera flujo de caja',
  precioSugerido: '💰 Sugerido',
  diasSinRotacion: 'días sin rotación',
  montoInvalido: '❌ El monto debe ser un número mayor a cero',
  errorGeneral: 'Error',
  aportePersonalRecomendacion: '💰 Aporte de capital personal. El negocio te debe este dinero.',
  dejarBlanco: 'Dejar en blanco si no aplica',
  
  // ============================================================
  // VALIDACIÓN DE FACTURA
  // ============================================================
  validarFactura: '📄 Validar Factura',
  proveedor: 'Proveedor',
  total: 'Total',
  impuestos: 'Impuestos',
  inventario: '📦 Inventario',
  gastos: '📋 Gastos',
  personal: '👤 Personal',
  ivaTotal: '💰 IVA Total',
  ivaEditable: '💡 El IVA es editable. Si el valor no es correcto, puedes modificarlo.',
  sinProductos: 'No se detectaron productos en la factura',
  alertaPersonal: '⚠️ Se detectaron {monto} en gastos personales. Esto no afecta tu negocio pero sí tu flujo de caja.',
  confirmar: 'Confirmar y Guardar',
  
  // ============================================================
  // ONBOARDING Y TOUR
  // ============================================================
  onboardingWelcome: '👋 Hola, te voy a ayudar a saber si tu negocio gana dinero.',
  onboardingQuestion: '¿Cómo manejas hoy tu negocio?',
  notebook: '📒 Cuaderno o papel',
  excelSoftware: '💻 Excel o software',
  accountingSoftware: '📊 Software contable',
  noControl: '📭 No llevo control',
  onboardingDone: '¡Listo! Con estos datos ya puedo mostrarte algo útil.',
  
  // ============================================================
  // TOOLTIPS
  // ============================================================
  tooltipSales: 'Total de ingresos por ventas en el mes actual',
  tooltipProfit: 'Ingresos menos gastos del período',
  tooltipMargin: 'Porcentaje de utilidad sobre ventas',
  tooltipBalance: 'Saldo histórico acumulado (ingresos - egresos)',
  tooltipCashRunway: 'Días que puedes operar con el saldo actual sin nuevos ingresos',
  tooltipBoneProduct: 'Producto sin ventas en más de 15 días - recomendación: liquidar con descuento',
  tooltipLowMargin: 'Margen inferior al 20% - riesgo en dropshipping si hay devoluciones',
  tooltipStarProduct: 'Producto con mayor facturación del período',
  tooltipBankruptcy: 'Alerta de flujo de caja - acción inmediata requerida',
  tooltipHealth: 'Indicador de salud financiera basado en margen neto',
  tooltipThermometer: 'Barra de salud: >30% Excelente, 15-30% Estable, <15% Crítico',
  
  // ============================================================
  // ALERTAS Y MENSAJES
  // ============================================================
  outlierAlert: '⚠️ Gasto atípico detectado',
  outlierAlertDesc: 'Este gasto supera significativamente tu promedio. ¿Es correcto?',
  inconsistencyAlert: '⚠️ Inconsistencia en saldo contable',
  inconsistencyAlertDesc: 'El saldo calculado no coincide con la suma de movimientos. Revisa los registros.',
  belowBreakEven: 'Por debajo del punto de equilibrio',
  marginDrop: 'Margen en caída',
  noCriticalAlerts: 'No hay alertas críticas. El negocio fluye según lo planeado.',
  bankruptcyAlert: '🔥 ALERTA DE QUIEBRA',
  noSalesAlert: '📢 Aún no has registrado ventas. Activa tu estrategia comercial para empezar a generar ingresos.',
  
  // ============================================================
  // CRECIMIENTO Y PUNTO DE EQUILIBRIO
  // ============================================================
  growth: 'Crecimiento',
  decline: 'Decrecimiento',
  breakEvenPointTitle: 'Punto de Equilibrio',
  breakEvenDesc: 'Ventas necesarias para cubrir costos fijos',
  alertBreakEven: '⚠️ Estás por debajo del punto de equilibrio. Necesitas vender más para cubrir costos fijos.',
  
  // ============================================================
  // LOGIN Y AUTENTICACIÓN
  // ============================================================
  loginTitle: 'Bienvenido a STRATIUM GLOBAL AI',
  loginSubtitle: 'Tu asistente financiero con IA',
  email: 'Correo electrónico',
  password: 'Contraseña',
  confirmPassword: 'Confirmar Contraseña',
  nombre: 'Nombre (opcional)',
  login: 'Iniciar Sesión',
  register: 'Registrarse',
  noAccount: '¿No tienes cuenta?',
  hasAccount: '¿Ya tienes cuenta?',
  switchToRegister: 'Regístrate aquí',
  switchToLogin: 'Inicia sesión aquí',
  plan: 'Plan',
  gratis: 'Gratis (15 días)',
  pro: 'Pro',
  business: 'Business',
  elite: 'Elite',
  loadingAuth: 'Cargando autenticación...',
  errorAuth: 'Error de autenticación',
  showPassword: 'Mostrar',
  hidePassword: 'Ocultar',
  passwordsDontMatch: 'Las contraseñas no coinciden',
  
  // ============================================================
  // MODAL UPGRADE
  // ============================================================
  upgradeTitle: 'Función no disponible',
  upgradeDescription: 'es exclusiva de los planes de pago',
  upgradePro: 'Pro',
  upgradeBusiness: 'Business',
  upgradeElite: 'Elite',
  upgradeButton: 'Ver Planes y Precios',
  starterPlan: 'Prueba 15 días',
  plan1: 'Pro',
  plan2: 'Business',
  plan3: 'Elite',
  
  // ============================================================
  // PAQUETES DE ESCANEOS
  // ============================================================
  masPopular: 'Más popular',
  paquetesEscaneos: 'PAQUETES ADICIONALES DE ESCANEOS',
  paqueteBasico: 'Básico',
  paqueteFrecuente: 'Frecuente',
  paqueteProfesional: 'Profesional',
  paqueteCorporativo: 'Corporativo',
  paquetesNota: 'Los paquetes se compran dentro de la app y NO están incluidos en el plan mensual',
  creditPackages: 'CRÉDITOS ADICIONALES PARA SOPORTE IA',
  consultasIA: 'consultas IA',
  creditosNota: '💡 Los créditos se suman a tu plan actual y NO caducan mensualmente.',
  
  // ============================================================
  // PLANES (DETALLES)
  // ============================================================
  plansStarterTagline: 'Consejero financiero de bolsillo',
  plansStarterFeature1: '10 escaneos/mes',
  plansStarterFeature2: 'Registro manual de movimientos',
  plansStarterFeature3: 'Dashboard financiero básico',
  plansStarterFeature4: 'Alertas de riesgo',
  plansStarterFeature5: 'Soporte IA 20 mensajes/mes',
  plansStarterFeature6: 'Sin reportes PDF',
  plansStarterFeature7: 'Sin exportar CSV',
  
  plansProTagline: 'Digitalización inteligente',
  plansProFeature1: '30 escaneos/mes',
  plansProFeature2: 'Registro manual ilimitado',
  plansProFeature3: 'Reportes PDF completos',
  plansProFeature4: 'Exportar CSV',
  plansProFeature5: 'Comparación mensual',
  plansProFeature6: 'Punto de equilibrio',
  plansProFeature7: 'Rotación de inventario',
  plansProFeature8: 'Soporte IA 50 mensajes/mes',
  
  plansBusinessTagline: 'Auditoría de sobrecostos',
  plansBusinessFeature1: '120 escaneos/mes',
  plansBusinessFeature2: 'Todo el plan Pro',
  plansBusinessFeature3: 'Auditoría forense de gastos',
  plansBusinessFeature4: 'Detección de sobrecostos de proveedores',
  plansBusinessFeature5: '3 usuarios incluidos',
  plansBusinessFeature6: 'Historial de eliminaciones',
  plansBusinessFeature7: 'Soporte IA 200 mensajes/mes',
  
  plansEliteTagline: 'Radar de quiebra',
  plansEliteFeature1: '300 escaneos/mes',
  plansEliteFeature2: 'Todo el plan Business',
  plansEliteFeature3: 'Radar de quiebra (90 días)',
  plansEliteFeature4: 'Alertas predictivas WhatsApp',
  plansEliteFeature5: 'Certificado Salud Financiera (QR)',
  plansEliteFeature6: '10 usuarios incluidos',
  plansEliteFeature7: 'Soporte IA 500 mensajes/mes',
  
  // ============================================================
  // OCR Y ARCHIVOS
  // ============================================================
  procesandoOCR: 'Procesando factura con OCR...',
  escanearFactura: 'Escanear factura',
  
  // ============================================================
  // TÉRMINOS Y CONDICIONES
  // ============================================================
  aceptarTerminos: 'Acepto los Términos y Condiciones y autorizo el tratamiento de mis datos personales.',
  terminosLink: 'Términos y Condiciones',
  
  // ============================================================
  // FECHA DE VENCIMIENTO
  // ============================================================
  preguntarVencimiento: '¿Registrar fecha de vencimiento?',
  fechaVencimiento: 'Fecha de vencimiento',
  guardarConVencimiento: 'Guardar con vencimiento',
  saltarVencimiento: 'Saltar (sin vencimiento)',
  producto: 'Producto',
  
  // ============================================================
  // SECCIÓN MI PLAN ACTUAL
  // ============================================================
  miPlanActual: 'Mi Plan Actual',
  gestionaSuscripcion: 'Gestiona tu suscripción',
  cambiarPlan: 'Cambiar Plan',
  escaneos: 'Escaneos',
  dias: 'Días',
  capitalInyectado: 'Capital Inyectado',
  
  // ============================================================
  // FOOTER Y METADATOS
  // ============================================================
  realtimeData: 'Datos actualizados en tiempo real desde Firebase',
  autoMonthlyClose: 'Cierre automático mensual el día 1',
  
  // ============================================================
  // REGISTROS Y REPORTES
  // ============================================================
  registros: 'Registros Financieros',
  dictamen: 'Dictamen de Auditoría',
  produccion: 'Cálculo de Producción',
  registroManual: 'Registro Manual de Movimientos',
  manualTransactionEntry: 'Registro Manual de Movimientos',
  financialRecords: 'Registros Financieros',
  auditReport: 'Dictamen de Auditoría',

  // ============================================================
  // CLAVES PARA DASHBOARD INSIGHTS (AGREGAR)
  // ============================================================
  boneProducts: '🦴 Productos Hueso',
  noBoneProducts: 'No hay productos hueso en inventario',
  salesTrend: '📈 Tendencia de Ventas',
  thisWeek: 'Esta semana',
  vsLastWeek: 'vs semana pasada',
  alertaCajaCritica: '🚨 ¡ALERTA! Tu saldo cubre solo {dias} días. Necesitas acción inmediata.',
  alertaCajaBaja: '⚠️ Tu saldo cubre solo {dias} días. Necesitas ${monto} para llegar a 5 días.',
  alertaMargenBajo: '📉 Tu margen neto es {margen}%. Está por debajo del 15% recomendado.',
  alertaInactividad: '📢 Llevas {dias} días sin registrar movimientos.',
  mensajePositivo: '✅ Todo está en orden. Sigue así para mantener tu negocio saludable.',
  starProducts: '⭐ Productos Estrella',
  noStarProducts: 'Aún no hay productos estrella. Registra más ventas.',
  starProductsTip: '⭐ Tu producto estrella es "{producto}". Destina presupuesto de marketing.',
  boneProductsTip: '🦴 Tienes {cantidad} productos sin rotación. Revisa precios.',
  lowMarginTip: '💰 Tus márgenes están bajos. Revisa costos o precios de venta.',
  positiveMessage: '✅ Todo marcha bien. Sigue así.',
  noSalesAlert: '📢 Aún no has registrado ventas. Activa tu estrategia comercial para empezar a generar ingresos.',
  
  // ============================================================
  // TÉRMINOS FINANCIEROS CORREGIDOS
  // ============================================================
  grossMargin: 'Margen Bruto',
  cashBalance: 'Saldo en Caja',
  cashOnHand: 'Efectivo en Caja',
  deadStock: 'Productos sin Rotación',
  topPerformers: 'Productos Destacados',
  businessFunds: '💰 Fondos del negocio',
  personalFunds: '👤 Fondos personales',
  
  // ============================================================
  // LEYENDA DEL GRÁFICO
  // ============================================================
  salesLegend: 'Ventas',
  expensesLegend: 'Gastos',
  purchasesLegend: 'Compras',
  capitalLegend: 'Capital',
  profitLegend: 'Utilidad',

"critical_products_title": "⚠️ Productos Críticos (Baja Rotación / Peligro de Quiebra)",
"no_critical_products": "✅ No tienes productos estancados en el inventario. El flujo es óptimo.",
productDetail: "Detalle del producto",
batchQuantity: "Cantidad del lote", 
totalMfgHours: "Horas totales de Fabricación",
estimatedSellingPrice: "Precio estimado de venta",
materialCostPerBatch: "Costo de materiales por lote",
hoursPlaceholder: "Horas",
materialsPlaceholder: "Materiales totales",
totalHoursTooltip: "Horas TOTALES para fabricar este producto",
totalMaterialsTooltip: "Costo TOTAL de materiales para este lote",
suggestedStrategy: "ESTRATEGIA SUGERIDA:",
ideal50: "Ideal (50%)",
phase30_40: "30 días (40%)",
phase60_30: "60 días (30%)",
phase90_10: "90 días (10%)",
projectedDays: "días proyectados de cobertura",
upgradeToBusiness: "Business/Elite",
upgradeToContinue: "Renueva para continuar",

// ============================================================
// DASHBOARD INSIGHTS ALERTS (ESPAÑOL)
// ============================================================
cashCoverageBelowTarget: "Cobertura de caja por debajo del objetivo de tu plan ({days} días)",
daysWithoutRecords: "{days} días sin registrar operaciones en el sistema",
netMarginBelowRecommended: "Margen neto ({margin}%) por debajo del mínimo recomendado (15%)",
priorityOne: "Prioridad 1: Gestionar cobro de facturas vencidas o lanzar oferta de liquidez líquida",
noSalesYet: "Aún no has registrado ventas. Activa tu estrategia comercial para empezar a generar ingresos.",
boostProduct: "Potencia el producto: \"{product}\". Es tu mayor generador de flujo.",
boneLiquidate: "Bone: Tienes {count} referencias sin rotación. Líquidalas al costo para recuperar caja.",
marginsAreLow: "Tus márgenes están bajos. Revisa costos o precios de venta.",
indicatorsUnderControl: "✅ Indicadores operativos bajo control.",
salesTrendUp: "Tendencia de ventas al alza",
salesTrendDown: "Tendencia de ventas a la baja",
daysCoveredGoal: "días objetivo de cobertura",
availableToday: "Disponible hoy",
planTarget: "Meta del plan",
sargentDiagnostic: "🚨 Diagnóstico del Sargento Financiero",
recommendedAction: "💡 Acción Recomendada",
salesTrendText: "📈 Tendencia de Ventas",
thisWeekSales: "Esta semana",
vsLastWeekSales: "vs semana pasada",
forgotPassword: "¿Olvidaste tu contraseña?",
resendVerification: "📧 Reenviar correo de verificación",
hasAccount: "¿Ya tienes una cuenta?",
noAccount: "¿No tienes una cuenta?",
switchToLogin: "Inicia sesión aquí",
switchToRegister: "Regístrate aquí",

  // ============================================================
  // VARIOS
  // ============================================================
  ejemplo: 'Ej: "Compra 10 gorras por 125.000" o "Genera: Reporte"',
  verHistorial: 'Ver historial completo',
  variacionVentas: 'vs mes anterior',
  crecimiento: 'Crecimiento',
  decrecimiento: 'Decrecimiento',
  conectar: 'Conectando...',
  enLinea: 'En línea',
  adjuntando: 'Adjuntando...',
  generando: 'Generando...',
  idioma: 'Idioma',
  español: 'Español',
  ingles: 'English',
  calcular: 'Calculando...',
  cargarInventario: 'Cargar a Inventario',
  oxigeno: 'Oxígeno financiero',
  salud: 'Termómetro de Salud',
  ingresosVsEgresos: 'Ingresos vs Egresos',
  configurarAuditoria: 'Configurar',
  verLogsEliminaciones: 'Ver historial de eliminaciones',
  cerrar: 'Cerrar',
  pago_exitoso: '✅ Pago exitoso. Tu plan ha sido actualizado.',
  error_pago: 'Error en el pago',

    // ============================================================
  // DEVOLUCIONES Y REEMBOLSOS
  // ============================================================
  devolucionVenta: '⬅️ Devolución en Venta',
  devolucionCompra: '➡️ Devolución en Compra',
  datosDevolucion: '📋 Datos de la devolución',
  productoDevuelto: 'Producto devuelto',
  cantidadDevuelta: 'Cantidad devuelta',
  accionDevolucion: 'Acción a tomar',
  reembolsoDinero: 'Reembolso en dinero',
  cambioProducto: 'Cambio por otro producto',
  perdidaInventario: 'Pérdida (no entra a inventario)',
  productoNuevo: 'Producto nuevo para cambio',
  cantidadNuevo: 'Cantidad nuevo producto',
  motivoDevolucion: 'Motivo de la devolución',
  motivoPlaceholder: 'Ej: Producto defectuoso, talla incorrecta, etc.',
  devolucionExitosa: '✅ Devolución registrada exitosamente',
  productoNuevoRequerido: '❌ Debes especificar el producto nuevo para el cambio',
  productoNuevoNoExiste: '❌ El producto no existe en inventario',
  stockInsuficienteNuevo: '❌ Stock insuficiente del producto nuevo',
  nombreProductoDevuelto: 'Ej: Pantalón de Hombre',
  nombreProductoNuevo: 'Ej: Camisa Manga Larga',
  productoNoExiste: '❌ El producto no existe en inventario'
};

